import "core-js/modules/es.array.includes.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.map.js";
import { defineComponent, reactive, toRefs, ref, computed, onMounted, watch } from 'vue';
import phoneBarTimer from './phoneBarTimes.vue';
import formItem from './formItem.vue';
// import recentCalls from './recent-calls.vue'
import move from './directive/move';
import { deepClone } from './common';
import { ElMessage } from 'element-plus';
import { isNumber } from './validate';
// import inputSuffix from '@/common/components/input-suffix.vue'
import { int } from './directive/input-int';
// import { newDate } from '@/common/utils/common'
import transferOprate from './transfer-oprate.vue';
import consuleOprate from './consule-oprate.vue';
import callQueue from '@/components/callQueue.vue';
import networkDelay from '@/components/networkdelay.vue';
import translationTxt from '@/components/translationTxt.vue';
// import ueSoftphone from 'ue-softphone-sdk'
import ueSoftphone from 'ue-softphone-sdk-beta';
export default defineComponent({
  name: 'telephoneStrip',
  components: {
    phoneBarTimer,
    formItem,
    transferOprate,
    consuleOprate,
    callQueue,
    networkDelay,
    translationTxt
    // recentCalls,
    // inputSuffix
  },
  directives: {
    move,
    int
  },
  // ----------------生命周期-----------------------
  created() {
    // const scriptLabel = document.createElement('script')
    // scriptLabel.type = 'text/javascript'
    // scriptLabel.src = 'https://v7-fs-call.7moor.com/v7sdk/V7Softphone-2.0.1.min.js'
    // document.head.appendChild(scriptLabel)
    // scriptLabel.onload = () => {
    //   try {
    //     this.initPhone()
    //     let wsUrl = ''
    //     this.pushServe.some((item: any) => {
    //       if (item.id === 'KF') {
    //         wsUrl = item.url
    //         return true
    //       }
    //     })
    //     console.log(wsUrl, 'ooooooooooooooo')
    //     this.CALLSTATE.initConnect()
    //   } catch (error: any) {
    //     console.log(error, '加载sdk文件失败')
    //   }
    // }
    this.initPhone();
  },
  setup() {
    const kickDestroy = ref(true);
    // ----------------传入属性-----------------------
    const phoneBarPeerTimeRef = ref(null);
    const phoneBarStatusTimeRef = ref(null);
    const phoneBarQuickStatusTimeRef = ref(null);
    const quickBar = ref(null);
    const callQueueBar = ref(false); //呼叫队列是否展示
    const callQueueBarMsg = ref(null); //呼叫队列信息
    const callQueueBarTimer = ref(false); //呼叫队列开启定时器
    const networkDelayBar = ref(false); //网络监测是否展示
    const networkdelayBarMsg = ref({}); //网络监测信息
    //电话条盒子是否可以移动
    const phoneMove = ref({
      isDraggable: false,
      position: {
        top: 150,
        left: 90
      }
    });
    //呼叫队列盒子是否可以移动
    const quickBarMove = ref({
      isDraggable: false,
      position: {
        top: 157,
        left: 490
      }
    });
    // 网络盒子是否可以移动
    const networkDelayBarMove = ref({
      isDraggable: false,
      position: {
        top: 157,
        left: 620
      }
    });
    // 实时转译盒子是否可以移动
    const nlsTranslationBarMove = ref({
      isDraggable: false,
      position: {
        top: 157,
        left: 680
      }
    });
    const openNlsTranslationBar = ref(false); //实时转译是否展示
    const openNlsTranslationBarMsg = ref([]); //实时转译监测信息
    // ----------------内部属性-----------------------
    const state = reactive({
      hangupState: '',
      actionModule: 'transfer',
      errorObj: {
        isError: false,
        type: '',
        message: ''
      },
      // 状态类型，根据状态类型显示颜色 free/busy/calling/called/disconnect
      stateType: 'free',
      currentCallType: '',
      // stateType: 'called',
      // 展示通话配置
      showConfig: false,
      callConfig: {
        autoAnswer: false,
        sipNumber: '',
        autoAnswerTime: '0',
        mobile: '',
        loginType: ''
      },
      showNum: true,
      accountConfig: {
        forbidDialInHangup: false,
        forbidDialOutHangup: false,
        ringCard: false // 来电振铃卡片是否展开
      },
      defaultConfig: {},
      AnswerOffline: false,
      sipNumberList: [],
      dialoutNumber: '',
      // 控制操作按钮
      renderMap: {
        PSTN_INVALID: ['dialout'],
        PSTN_CALLIN_CALLING: ['hangup'],
        PSTN_CALLOUT_CALLING: ['hangup'],
        PSTN_CALLIN_RING: ['hangup', 'animation'],
        PSTN_CALLOUT_RING: ['hangup'],
        PSTN_TRANSFER_RING: ['hangup', 'animation'],
        PSTN_CALLIN_LINK: ['hangup', 'hold', 'mute', 'transfer', 'concul', 'satisfaction'],
        PSTN_CALLOUT_LINK: ['hangup', 'hold', 'mute', 'transfer', 'concul', 'satisfaction'],
        PSTN_TRANSFER_LINK: ['hangup', 'hold', 'mute', 'transfer', 'concul', 'satisfaction'],
        PSTN_TRANSFER_ARRANGE: ['dialout'],
        PSTN_CONSULTTRANSFER_LINK: ['hangup', 'hold', 'mute', 'transfer', 'concul', 'satisfaction'],
        PSTN_CALLIN_MUTE: ['hangup', 'mutecancel'],
        PSTN_CALLOUT_MUTE: ['hangup', 'mutecancel'],
        PSTN_CONSULTTRANSFER_MUTE: ['hangup', 'mutecancel'],
        PSTN_CALLIN_HOLD: ['hangup', 'holdcancel'],
        PSTN_CALLOUT_HOLD: ['hangup', 'holdcancel'],
        PSTN_CONSULTTRANSFER_HOLD: ['hangup', 'holdcancel'],
        PSTN_CALLIN_ARRANGE: ['dialout'],
        PSTN_CALLOUT_ARRANGE: ['dialout'],
        PSTN_CONSULTTRANSFER_ARRANGE: ['dialout'],
        PSTN_BUSY: ['dialout'],
        PSTN_CALLOUT_BUSY: ['dialout'],
        PSTN_CALLIN_BUSY: ['dialout'],
        PSTN_DISCONNECTED: ['showquick'],
        WAITCONSUL: ['hangup', 'cancelconcul'],
        CONSULCANCEL: ['hangup', 'concul', 'takeback'],
        CONSULPICKUP: ['hangup', 'endconsul', 'threepartycall', 'concultransfer'],
        CONSULING: ['hangup'],
        THREECALL: ['hangup'],
        LISTEN: ['hangup'],
        WHISPER: ['hangup'],
        PSTN_CONSULT_RING: ['hangup'],
        //
        SIP_INVALID: ['dialout'],
        SIP_CALLIN_CALLING: ['hangup'],
        SIP_CALLOUT_CALLING: ['hangup'],
        SIP_CALLIN_RING: ['hangup'],
        SIP_CALLOUT_RING: ['hangup'],
        SIP_TRANSFER_RING: ['hangup'],
        SIP_CALLIN_LINK: ['hangup', 'hold', 'mute', 'transfer', 'concul', 'satisfaction'],
        SIP_CALLOUT_LINK: ['hangup', 'hold', 'mute', 'transfer', 'concul', 'satisfaction'],
        SIP_TRANSFER_LINK: ['hangup', 'hold', 'mute', 'transfer', 'concul', 'satisfaction'],
        SIP_CONSULTTRANSFER_LINK: ['hangup', 'hold', 'mute', 'transfer', 'concul', 'satisfaction'],
        SIP_CALLIN_MUTE: ['hangup', 'mutecancel'],
        SIP_CALLOUT_MUTE: ['hangup', 'mutecancel'],
        SIP_CONSULTTRANSFER_MUTE: ['hangup', 'mutecancel'],
        SIP_CALLIN_HOLD: ['hangup', 'holdcancel'],
        SIP_CALLOUT_HOLD: ['hangup', 'holdcancel'],
        SIP_CONSULTTRANSFER_HOLD: ['hangup', 'holdcancel'],
        SIP_CALLIN_ARRANGE: ['dialout'],
        SIP_CALLOUT_ARRANGE: ['dialout'],
        SIP_CONSULTTRANSFER_ARRANGE: ['dialout'],
        SIP_TRANSFER_ARRANGE: ['dialout'],
        SIP_BUSY: ['dialout'],
        SIP_CALLOUT_BUSY: ['dialout'],
        SIP_CALLIN_BUSY: ['dialout'],
        SIP_DISCONNECTED: ['showquick'],
        SIP_CONSULT_RING: ['hangup'],
        //
        WEBRTC_INVALID: ['dialout', 'disconnect'],
        WEBRTC_CALLIN_CALLING: ['hangup'],
        WEBRTC_CALLOUT_CALLING: ['hangup'],
        WEBRTC_CALLIN_RING: ['hangup', 'answer'],
        WEBRTC_CALLOUT_RING: ['hangup'],
        WEBRTC_TRANSFER_RING: ['hangup', 'answer', 'animation'],
        WEBRTC_CALLIN_LINK: ['hangup', 'hold', 'mute', 'key', 'transfer', 'concul', 'satisfaction'],
        WEBRTC_CALLOUT_LINK: ['hangup', 'hold', 'mute', 'key', 'transfer', 'concul', 'satisfaction'],
        WEBRTC_TRANSFER_LINK: ['hangup', 'hold', 'mute', 'transfer', 'concul', 'satisfaction', 'key'],
        WEBRTC_CONSULTTRANSFER_LINK: ['hangup', 'hold', 'mute', 'key', 'transfer', 'concul', 'satisfaction'],
        WEBRTC_CALLIN_MUTE: ['hangup', 'mutecancel'],
        WEBRTC_CALLOUT_MUTE: ['hangup', 'mutecancel'],
        WEBRTC_CONSULTTRANSFER_MUTE: ['hangup', 'mutecancel'],
        WEBRTC_CALLIN_HOLD: ['hangup', 'holdcancel'],
        WEBRTC_CALLOUT_HOLD: ['hangup', 'holdcancel'],
        WEBRTC_CONSULTTRANSFER_HOLD: ['hangup', 'holdcancel'],
        WEBRTC_CALLIN_ARRANGE: ['dialout'],
        WEBRTC_CALLOUT_ARRANGE: ['dialout'],
        WEBRTC_CONSULTTRANSFER_ARRANGE: ['dialout'],
        WEBRTC_TRANSFER_ARRANGE: ['dialout'],
        WEBRTC_DISCONNECTED: ['connect', 'showquick'],
        WEBRTC_BUSY: ['dialout'],
        WEBRTC_CALLOUT_BUSY: ['dialout'],
        WEBRTC_CALLIN_BUSY: ['dialout'],
        WEBRTC_CONSULT_RING: ['hangup', 'answer'],
        // 转接
        TRANSFER_OPRATE: ['transferoprate', 'hangup'],
        // 咨询
        CONSULE_OPRATE: ['consuleoprate', 'hangup'],
        WEBRTC_INNER_RING: ['hangup', 'answer'],
        WEBRTC_TWOWAYCALL_RING: ['hangup', 'answer']
      },
      currentStatus: 'PSTN_INVALID',
      // currentStatus: 'WEBRTC_DIALOUT_LINK',
      currentStatusName: '空闲',
      // 外呼或呼入号码
      callingNumber: '',
      keyList: ['1', '2', '3', '4', '5', '6', '7', '8', '9'],
      loginType: '',
      loginTypeMap: {
        PSTN: '手机模式',
        SIP: 'SIP话机',
        WEBRTC: '软电话'
      },
      loginTypeList: [{
        value: 'PSTN',
        label: '手机模式'
      }, {
        value: 'SIP',
        label: 'SIP话机'
      }, {
        value: 'WEBRTC',
        label: '软电话'
      }],
      ivrList: [],
      agentStatusList: [],
      agentStatusNumber: '',
      isTransterBtn: true,
      isOpenpanel: false,
      quickToWhole: false,
      // 前端控制交互状态
      // 默认不展示输入框
      showInput: false,
      // 默认键盘展示
      showDial: true,
      // 转接控制
      transferState: false,
      // 咨询控制
      consulSelect: false,
      // 软电话键盘控制
      webrtcKeyState: false,
      // 切换通话记录
      callRcentState: true,
      // 快捷操作状态
      quickState: false,
      // 客户信息
      customerInfo: {
        number: '',
        name: '',
        place: '',
        tag: '',
        displayNumber: '',
        active: false // 客户信息展示是否被激
      },
      // 返回上一个状态
      backStatus: '',
      switchQuickState(currentState) {
        state.quickState = currentState;
      },
      switchKey(keyState) {
        state.callRcentState = keyState;
      },
      setTransferState(transCancelState) {
        if (transCancelState) {
          state.backStatus = state.currentStatus;
          state.currentStatus = 'TRANSFER_OPRATE';
        } else {
          state.currentStatus = state.backStatus;
        }
      },
      setConsulState(consulCancelState) {
        if (consulCancelState) {
          state.backStatus = state.currentStatus;
          state.currentStatus = 'CONSULE_OPRATE';
        } else {
          state.currentStatus = state.backStatus;
        }
      },
      setWebrtcKeyState(cancelWebrctKey) {
        state.webrtcKeyState = cancelWebrctKey;
      },
      toAnswerOffline(v) {
        const toAnswerOffline = v ? '1' : '0';
        window.ueSoftphone.agent.setAnswerOffline({
          toAnswerOffline: toAnswerOffline,
          success: () => {
            console.log({
              message: '设置成功',
              type: 'success'
            });
          },
          fail: () => {
            console.log({
              message: '设置失败',
              type: 'error'
            });
          }
        });
      },
      inputChange(v) {
        if (/^[0-9*#]*$/.test(v)) {
          state.dialoutNumber = v;
        }
      },
      initPhone() {
        let params;
        if (window && window.ueSimpleSoftphone && window.ueSimpleSoftphone.initParams) {
          params = window.ueSimpleSoftphone.initParams;
          callQueueBar.value = params.isOpenCallQueue ? true : false;
          networkDelayBar.value = params.isOpenNetwork ? true : false;
          openNlsTranslationBar.value = params.openNlsTranslation ? true : false;
          phoneMove.value = params.phoneMoveMsg ? params.phoneMoveMsg : {
            isDraggable: true,
            position: {
              top: 150,
              left: 90
            }
          };
          quickBarMove.value = params.quickBarMoveMsg ? params.quickBarMoveMsg : {
            isDraggable: true,
            position: {
              top: 157,
              left: 490
            }
          };
          networkDelayBarMove.value = params.networkMoveMsg ? params.networkMoveMsg : {
            isDraggable: true,
            position: {
              top: 157,
              left: 620
            }
          };
          nlsTranslationBarMove.value = params.nlsMoveMsg ? params.nlsMoveMsg : {
            isDraggable: true,
            position: {
              top: 157,
              left: 680
            }
          };
        } else {
          params = {
            // accountId: 'useasyTest',
            // agentNumber: '8042',
            accountName: '8005@uecs1',
            password: '123456Aa',
            // accountName: '8045@useasyTest',
            // password: 'Aa123456',
            isOpenCallQueue: true,
            isOpenNetwork: true,
            openNlsTranslation: true,
            loginType: 'WEBRTC',
            phoneMoveMsg: {
              isDraggable: true,
              position: {
                top: 150,
                left: 90
              }
            },
            server: 'https://dev1.useasy.cn/api'
          };
          callQueueBar.value = params.isOpenCallQueue ? true : false;
          networkDelayBar.value = params.isOpenNetwork ? true : false;
          openNlsTranslationBar.value = params.openNlsTranslation ? true : false;
          phoneMove.value = params.phoneMoveMsg ? params.phoneMoveMsg : {
            isDraggable: true,
            position: {
              top: 150,
              left: 90
            }
          };
          quickBarMove.value = params.quickBarMoveMsg ? params.quickBarMoveMsg : {
            isDraggable: true,
            position: {
              top: 157,
              left: 490
            }
          };
          networkDelayBarMove.value = params.networkMoveMsg ? params.networkMoveMsg : {
            isDraggable: true,
            position: {
              top: 157,
              left: 620
            }
          };
          nlsTranslationBarMove.value = params.nlsMoveMsg ? params.nlsMoveMsg : {
            isDraggable: true,
            position: {
              top: 157,
              left: 680
            }
          };
          // params = {
          //   accountId: 'useasyTest',
          //   agentNumber: '8042',
          //   password: 'Aa123456',
          //   loginType: 'WEBRTC'
          // }
        }
        const loginType = params.loginType || 'WEBRTC';
        window.ueSoftphone = new ueSoftphone({
          accountId: params.accountId,
          agentNumber: params.agentNumber,
          accountName: params.accountName ? params.accountName : '',
          password: params.password || '',
          passwordPk: params.passwordPk || '',
          loginType: loginType,
          server: params.server || null,
          isOpenCallQueue: params.isOpenCallQueue || false,
          isOpenNetwork: params.isOpenNetwork || false,
          openNlsTranslation: params.openNlsTranslation || false,
          error(error) {
            if (error.code === '2005') {
              state.errorObj.isError = true;
              state.errorObj.message = '当前License数量不足请联系管理员';
            } else if (error.message) {
              console.log({
                message: error.message,
                type: 'error'
              });
            }
            if (window.ueSimpleSoftphone && window.ueSimpleSoftphone.error) {
              window.ueSimpleSoftphone.error({
                message: error.message,
                type: 'error'
              });
            }
          },
          success(data) {
            if (window.ueSimpleSoftphone && window.ueSimpleSoftphone.success) {
              window.ueSimpleSoftphone.success({
                message: '初始化成功',
                code: 200
              });
            }
            state.callConfig.loginType = loginType;
            state.errorObj.isError = false;
            // state.initUserConfig(data)
            state.getAgentPhoneBarList();
            state.getAvailableSipNumberList();
          }
        });
        window.ueSoftphone.listenCallEvent({
          event: res => {
            const data = res.data;
            if (window.ueSimpleSoftphone && window.ueSimpleSoftphone.backEventFunction) {
              window.ueSimpleSoftphone.backEventFunction(res);
            }
            if (data.subType === 'KICK_OFF' && data.data.kickoff) {
              kickDestroy.value = false;
            }
          },
          success(msg) {
            if (window.ueSimpleSoftphone && window.ueSimpleSoftphone.backEventFunction) {
              window.ueSimpleSoftphone.backEventFunction(msg);
            }
          },
          error(error) {
            if (window.ueSimpleSoftphone && window.ueSimpleSoftphone.backEventFunction) {
              window.ueSimpleSoftphone.backEventFunction(error);
            }
            if (error.message) {
              console.log({
                message: error.message,
                type: 'error'
              });
            }
          },
          message: res => {
            const data = res.data;
            if (res.subtype === 'status') {
              state.currentStatusName = data.stateName;
              const timeType = data.state === '5' ? 'countDown' : 'timing';
              if (data.statusTime) {
                state.timeRecording(timeType, data.statusTime);
              } else {
                state.timeRecording(timeType);
              }
            } else if (res.subtype === 'login') {
              state.loginType = data.loginType || 'WEBRTC';
            }
            if (window.ueSimpleSoftphone && window.ueSimpleSoftphone.backEventFunction) {
              window.ueSimpleSoftphone.backEventFunction(data);
            }
            state.hangupState = data.state;
            state.currentStatus = state.getCurrentStatus(data.state, data.callType, data.eventType);
          }
        });
        window.ueSoftphone.listenCallQueueEvent({
          success(res) {
            if (window.ueSimpleSoftphone && window.ueSimpleSoftphone.listenCallQueueEvent) {
              window.ueSimpleSoftphone.listenCallQueueEvent(res);
            }
          },
          message(res) {
            if (window.ueSimpleSoftphone && window.ueSimpleSoftphone.listenCallQueueEvent) {
              window.ueSimpleSoftphone.listenCallQueueEvent(res);
            }
            if (res.success) {
              //初始化接口获取的数据
              callQueueBarMsg.value = res.data;
              callQueueBarTimer.value = false;
            }
            if (res.subtype == 'queue') {
              //socket后期获取的数据
              callQueueBarMsg.value = callQueueBarMsg.value.map(item => {
                if (item.queueNumber === res.data.queueNumber) {
                  return {
                    ...item,
                    ...res.data
                  };
                }
                return item;
              }) || [];
              callQueueBarTimer.value = true;
            }
          },
          error(error) {
            console.error(error);
          }
        });
        window.ueSoftphone.listenTranslationEvent({
          success(res) {
            if (window.ueSimpleSoftphone && window.ueSimpleSoftphone.listenTranslationEvent) {
              window.ueSimpleSoftphone.listenTranslationEvent(res);
            }
            // openNlsTranslationBarMsg.value = [
            //   {
            //     side: 'agent',
            //     text: '你好，欢迎使用智能客服！'
            //   },
            //   {
            //     side: 'customer',
            //     text: '你好，有什么可以帮助您的吗？撒了；简单来说v你擦了弹尽粮绝发了饭你好，有什么可以帮助您的吗？撒了；简单来说v你擦了弹尽粮绝发了饭'
            //   },
            //   {
            //     side: 'agent',
            //     text: '德累斯顿肌肤垃圾里发进来房间名出啦，阿娇上的棱角分明次。德累斯顿肌肤垃圾里发进来房间名出啦，阿娇上的棱角分明次'
            //   }
            // ]
            // setInterval(() => {
            //   openNlsTranslationBarMsg.value.push({
            //     side: 'customer',
            //     text: '你好，有什么可以帮助您的吗？撒了；简单来说v你擦了弹尽粮绝发了饭你好，有什么可以帮助您的吗？撒了；简单来说v你擦了弹尽粮绝发了饭'
            //   })
            // }, 2000)
          },
          message(res) {
            if (window.ueSimpleSoftphone && window.ueSimpleSoftphone.listenTranslationEvent) {
              window.ueSimpleSoftphone.listenTranslationEvent(res);
            }
            //转译
            if (res.subtype == 'translation') {
              if (res.data.eventType == 'translationStart') {
                //接收到开始事件清空数据
                openNlsTranslationBarMsg.value = [];
              }
              if (res.data.eventType == 'translationText') {
                openNlsTranslationBarMsg.value.push(res.data);
              }
            }
          }
        });
        window.ueSoftphone.listenCallNetork({
          message(res) {
            if (window.ueSimpleSoftphone && window.ueSimpleSoftphone.listenCallNetork) {
              window.ueSimpleSoftphone.listenCallNetork(res);
            }
            networkdelayBarMsg.value = res;
            console.log(res, '简易监听网络检测事件');
          }
        });
      },
      setCustomerInfo(event) {
        const callType = event.callType || '';
        const callEvent = event.callEvent || '';
        if (state.stateType === 'calling' || state.stateType === 'ring' || state.stateType === 'called') {
          // 激活中才会赋值客户信息
          if (callType === 'dialout') {
            state.customerInfo.displayNumber = event.displayNumber ? '外显号：' + event.displayNumber : '';
          } else {
            state.customerInfo.displayNumber = event.trunkNumber ? '服务号：' + event.trunkNumber : '';
          }
          if (event.number) {
            state.customerInfo.number = event.number;
            if (!state.customerInfo.name) {
              if (!state.customerInfo.active) {
                state.customerInfo.active = true;
              }
              console.log('未设置名称');
            }
          }
          let place = '';
          if (event.customerCountryCode === '86') {
            if (event.customerProvince) {
              place = event.customerProvince + '-' + event.customerCity;
            }
          } else {
            if (event.customerCountry) {
              place = event.customerCountry;
            }
          }
          state.customerInfo.place = place;
        }
        if (!['calling', 'called', 'ring'].includes(state.stateType)) {
          state.customerInfo = {
            number: '',
            name: '',
            place: '',
            tag: '',
            displayNumber: '',
            active: false // 客户信息展示是否被激活
          };
        }
        console.log(event, '');
      },
      initPhoneOpenState() {
        const phoneUnfoldState = localStorage.getItem('phoneUnfoldState');
        if (phoneUnfoldState === null || phoneUnfoldState === 'true') {
          state.setUnfoldState(true);
        } else {
          state.setUnfoldState(false);
        }
      },
      setBack() {
        state.showDial = true;
        state.showConfig = false;
      },
      goToSetting() {
        state.showDial = false;
        state.showConfig = true;
        // state.callConfig = deepClone(state.defaultConfig) // 初始化
      },
      deleteNum() {
        if (state.dialoutNumber) {
          const length = state.dialoutNumber.length;
          state.dialoutNumber = state.dialoutNumber.substring(0, length - 1);
        }
      },
      dialout(dialoutNumber, state) {
        if (!state) {
          return;
        }
        if (!dialoutNumber) {
          ElMessage.error({
            message: '请填写外呼号码',
            type: 'error'
          });
          return;
        }
        if (window.ueSoftphone) {
          window.ueSoftphone.call.callout({
            customerNumber: dialoutNumber,
            success(res) {
              console.log({
                message: '外呼成功',
                type: 'success',
                duration: 5 * 1000
              });
            },
            fail(error) {
              ElMessage.error({
                message: error.message,
                type: 'error'
              });
              console.log({
                message: error.message,
                type: 'error'
              });
            }
          });
        }
      },
      hangup() {
        if (window.ueSoftphone) {
          window.ueSoftphone.call.hangup({
            fail(error) {
              console.error(error, 'error');
            }
          });
        }
      },
      holdOrUnHold(type) {
        if (window.ueSoftphone) {
          window.ueSoftphone.call.holdOrUnHold({
            type,
            fail(error) {
              console.error(error, 'error');
            }
          });
        }
      },
      muteOrUnMute(type) {
        if (window.ueSoftphone) {
          window.ueSoftphone.call.muteOrUnMute({
            type,
            fail(error) {
              console.error(error, 'error');
            }
          });
        }
      },
      resumeConsult() {
        window.ueSoftphone.call.callbackConsult({
          success: () => {
            console.log('取消咨询');
          }
        });
      },
      consultTransfer() {
        window.ueSoftphone.call.consultTransfer({
          success: () => {
            console.log('咨询转移成功');
          }
        });
      },
      threeWayCall() {
        window.ueSoftphone.call.threeWayCall({
          success: () => {
            console.log('三方通话成功');
          }
        });
      },
      stopConsult() {
        window.ueSoftphone.call.cancelconsult({
          success: () => {
            console.log('取消咨询');
          }
        });
      },
      cancelConsult() {
        window.ueSoftphone.call.cancelconsult({
          success: () => {
            console.log('取消咨询');
          }
        });
      },
      satisfaction() {
        window.ueSoftphone.call.evaluate({
          type: 'SATISFACTION'
        });
      },
      transOrUntrans() {
        state.isTransterBtn = !state.isTransterBtn;
      },
      accept() {
        window.ueSoftphone.webrtc.accept();
      },
      sendDTMF(key) {
        state.dialoutNumber += key;
        if (state.isVisibleBtn('key')) {
          window.ueSoftphone.call.sendDTMF(key);
        }
      },
      connect() {
        window.ueSoftphone = null;
        state.initPhone();
      },
      disconnect() {
        window.ueSoftphone.call.disconnect();
      },
      keyDowndialout(event) {
        if (event.keyCode === 13) {
          state.dialout(state.dialoutNumber, false);
        }
      },
      updateLoginType() {
        const {
          loginType,
          sipNumber
        } = state.callConfig;
        const data = {
          loginType
        };
        if (loginType === 'SIP' && sipNumber) {
          data.loginNumber = sipNumber;
        }
        window.ueSoftphone.agent.switchLoginType({
          ...data,
          success: () => {
            state.loginType = loginType;
            localStorage.setItem('phoneLoginType', loginType);
            state.setBack();
            state.updateCurrentStatus();
            console.log({
              message: '切换成功',
              type: 'success'
            });
          },
          fail: () => {
            console.log({
              message: '切换失败',
              type: 'error'
            });
          }
        });
      },
      getAgentPhoneBarList() {
        window.ueSoftphone.agent.findPhoneBarList({
          success: res => {
            state.agentStatusList = res.data;
          }
        });
        //  window.ueSoftphone.call.getAgentPhoneBarList().then((resp: any) => {
        //     state.agentStatusList = resp || []
        //   })
      },
      updateAgentStatus(stateNumber) {
        // window.ueSoftphone.agent.updateAgentStatus({
        //   statusNumber,
        //   success(res: any) {
        //     // console.log(res:any);
        //   }
        // })
        window.ueSoftphone.agent.switchPhoneBar({
          stateNumber
        });
      },
      getAvailableSipNumberList() {
        window.ueSoftphone.agent.getAvailableSipNumberList({
          success: res => {
            if (res.success) {
              state.sipNumberList = res.data;
            }
            // SIP话机模式需要绑定的number参数可以从这里获取
          }
        });
      },
      initUserConfig(userData) {
        state.AnswerOffline = userData.toAnswerOffline && userData.toAnswerOffline === '1' ? true : false;
      },
      isVisibleBtn(type) {
        if (state.currentStatus) {
          const mapData = state.renderMap[state.currentStatus] || '';
          console.log(mapData, 'mapData=====>>>', state.currentStatus);
          return mapData && mapData.indexOf(type) > -1;
        }
      },
      getCurrentStatus(statusNumber, type, callEvent) {
        let statusName = '';
        console.log(statusNumber, type, callEvent, '687678676');
        // if (callEvent) {
        //   state.stateType = 'disconnect'
        //   return (statusName = 'disconnect')
        // }
        if (type) {
          state.currentCallType = type;
        }
        const callType = type ? '_' + type.toUpperCase() : '';
        state.quickToWhole = false;
        switch (statusNumber) {
          case '0':
            statusName = state.loginType + '_INVALID';
            state.stateType = 'free';
            break;
          case '1':
            statusName = state.loginType + callType + '_BUSY';
            state.stateType = 'busy';
            break;
          case '2':
            statusName = state.loginType + callType + '_CALLING';
            state.stateType = 'calling';
            break;
          case '3':
            if (callEvent === 'consult') {
              // 转接振铃
              statusName = state.loginType + '_CONSULT_RING';
            } else {
              // 普通振铃
              statusName = state.loginType + callType + '_RING';
            }
            state.stateType = 'ring';
            break;
          case '4':
            // 通话中
            if (callEvent === 'consult') {
              // 点击咨询，等待被咨询方接起时的状态（咨询中）
              // 等待咨询 取消咨询
              statusName = 'WAITCONSUL';
            } else if (callEvent === 'callBack') {
              // 咨询中点击取消咨询
              // 取消咨询 咨询-接回
              statusName = 'CONSULCANCEL';
            } else {
              statusName = state.loginType + callType + '_LINK';
              // 挂断, 保持， 静音, 满意度，转接，咨询
            }
            state.stateType = 'called';
            break;
          case '5':
            // 忙碌
            statusName = state.loginType + callType + '_ARRANGE';
            state.stateType = 'busy';
            break;
          case '6':
            // 保持
            statusName = state.loginType + callType + '_HOLD';
            // 挂断， 取消保持
            state.stateType = 'called';
            break;
          case '7':
            // 静音
            statusName = state.loginType + callType + '_MUTE';
            // 挂断, 取消静音
            state.stateType = 'called';
            break;
          case '8':
            // 未连接
            statusName = state.loginType + callType + '_DISCONNECTED';
            state.stateType = 'disconnect';
            break;
          case '9':
            // 失效
            statusName = state.loginType + callType + '_DISCONNECTED';
            state.stateType = 'disconnect';
            break;
          case '10':
            // 咨询成功
            if (callEvent === 'callback') {
              // 点击结束咨询
              statusName = 'CONSULCANCEL';
              // 挂断，接回，咨询(可继续咨询其他人)
            } else {
              // 咨询接起 取消咨询 三方通话 咨询转移
              statusName = 'CONSULPICKUP';
            }
            state.stateType = 'called';
            break;
          case '11':
            // 三方
            statusName = 'THREECALL';
            state.stateType = 'called';
            break;
          case '12':
            // 咨询接起后，被咨询方的状态
            statusName = 'CONSULING';
            state.stateType = 'called';
            break;
          case '13':
            // 被三方
            statusName = 'THREECALL';
            state.stateType = 'called';
            break;
          case '14':
            // 监听
            statusName = 'LISTEN';
            state.stateType = 'called';
            break;
          case '15':
            // 耳语
            statusName = 'WHISPER';
            state.stateType = 'called';
            break;
          default:
            statusName = state.loginType + callType + '_BUSY';
            state.stateType = 'busy';
            break;
        }
        return statusName;
      },
      updateCurrentStatus() {
        const statusList = state.currentStatus.split('_');
        if (statusList[0] !== state.loginType) {
          statusList[0] = state.loginType;
          state.currentStatus = statusList.join('_');
        }
      },
      /**
       * 控制计时器
       * @param {string} type timing 正计时 or countDown 倒计时
       * @param {?string} timestamp 时间戳 从哪个时间开始记时 默认为函数执行时间
       */
      timeRecording(type, timestamp) {
        let second = 0;
        if (timestamp) {
          const beginDate = new Date(timestamp);
          const endDate = new Date();
          const diff = endDate.getTime() - beginDate.getTime();
          if (diff > 0) {
            second = diff / 1000;
          } else {
            second = 0;
          }
        }
        console.log(phoneBarPeerTimeRef, 'cccccccccccccccccccccccccccccccccccccccccccccc');
        phoneBarPeerTimeRef.value.timerTypeChange({
          timeType: type,
          statusTime: second
        });
        phoneBarStatusTimeRef.value.timerTypeChange({
          timeType: type,
          statusTime: second
        });
        phoneBarQuickStatusTimeRef.value.timerTypeChange({
          timeType: type,
          statusTime: second
        });
      },
      changeOpenState() {
        state.setUnfoldState(!state.isOpenpanel);
      },
      setUnfoldState(data) {
        state.isOpenpanel = data;
        localStorage.setItem('phoneUnfoldState', JSON.stringify(data));
      }
    });
    const interactive = reactive({
      setDialState(state) {
        state.showDial = state;
      },
      toggleDialState() {
        state.showDial = !state.showDial;
      }
    });
    // ----------------计算属性-----------------------
    // 接听按钮状态
    const acceptBtnState = computed(() => {
      return state.isVisibleBtn('answer');
    });
    watch(acceptBtnState, acceptBtnState => {
      // 自动接听
      if (acceptBtnState) {
        if (state.callConfig.autoAnswer) {
          const time = state.callConfig.autoAnswerTime ? Number(state.callConfig.autoAnswerTime) * 1000 : 0;
          setTimeout(() => {
            state.accept();
          }, time);
        }
      }
    });
    const pushServe = computed(() => {
      return '';
    });
    // 静止状态切换
    const disabledSwitch = computed(() => {
      return ['calling', 'called', 'ring'].includes(state.stateType);
    });
    watch(disabledSwitch, currentState => {
      // 通话中状态
      if (currentState) {
        // 振铃是否展开客户卡片
        // 通话中清空输入号码
        state.dialoutNumber = '';
        if (state.accountConfig.ringCard) {
          state.quickState = false;
        } else {
          state.quickState = true;
        }
      }
    });
    // 隐藏键盘和配置
    const hiddenOprate = computed(() => {
      console.log(state.stateType, '990990');
      return !['free', 'busy', 'disconnect'].includes(state.stateType) || state.errorObj.isError;
    });
    // 呼入挂断
    const showHangupBtn = computed(() => {
      if (state.currentCallType === 'callout' || state.currentCallType === 'callTask') {
        return !state.accountConfig.forbidDialOutHangup;
      } else if (state.currentCallType === 'callin' || state.currentCallType === 'inner') {
        return !state.accountConfig.forbidDialInHangup;
      } else {
        return true;
      }
    });
    // ----------------监听方法-----------------------
    const keyboard = reactive({
      defaultKeyboardPlaceholder: '输入号码点击回车键发起呼叫',
      showKeyboardPlaceholder: true
    });
    // ----------------调用方法-----------------------
    const changeType = () => {
      // 切换接听方式时清空其他方式的数据
      const obj = {
        ...state.defaultConfig,
        loginType: state.callConfig.loginType
      };
      state.callConfig = deepClone(obj);
    };
    const validFun = val => {
      if (!isNumber(val)) {
        state.callConfig.mobile = ''; // 清空数据
        ElMessage.error('只能输入数字');
      }
    };
    const handleParams = (params, type) => {
      switch (type) {
        case 'PSTN':
          params.mobile = state.callConfig.mobile;
          break;
        case 'SIP':
          params.agentCallConfig.sipNumber = state.callConfig.sipNumber;
          break;
        case 'WEBRTC':
          params.agentCallConfig.autoAnswer = state.callConfig.autoAnswer;
          if (state.callConfig.autoAnswer) {
            params.agentCallConfig.autoAnswerTime = Number(state.callConfig.autoAnswerTime);
          }
          break;
      }
    };
    const getSipNumbers = () => {
      // getSipNum({}).then((res: any) => {
      //   if (res.data) {
      //     state.sipNumberList = res.data || []
      //   }
      // })
    };
    onMounted(() => {
      getSipNumbers();
    });
    const isVisibleBtn = type => {
      if (state.currentStatus) {
        const mapData = state.renderMap[state.currentStatus] || '';
        return mapData && mapData.indexOf(type) > -1;
      }
    };
    return {
      ...toRefs(state),
      ...toRefs(keyboard),
      ...toRefs(interactive),
      isVisibleBtn,
      disabledSwitch,
      hiddenOprate,
      phoneBarPeerTimeRef,
      phoneMove,
      quickBarMove,
      networkDelayBarMove,
      nlsTranslationBarMove,
      phoneBarStatusTimeRef,
      phoneBarQuickStatusTimeRef,
      pushServe,
      validFun,
      changeType,
      showHangupBtn,
      kickDestroy,
      callQueueBar,
      callQueueBarMsg,
      callQueueBarTimer,
      networkDelayBar,
      networkdelayBarMsg,
      openNlsTranslationBar,
      openNlsTranslationBarMsg
    };
  }
});